<template>
    <VariantItem
        :is-active="active"
        :dense="dense"
        class="variant-option"
        :class="{
            'variant-option--emphasized': !!hint || emphasize,
            'variant-option--active': active
        }"
		role="button"
		tabindex="0"
    >
        <template #title>
            {{ title }}
        </template>

        <template v-if="subtitle" #subtitle>
            <slot name="subtitle">
                <div class="align-self-center">{{ subtitle }}</div>
            </slot>
        </template>

        <template v-if="priceWithSign" #price>
            <Price
                :minimum-per-person-price="minimumPersonPrice"
                :minimum-price="minimumPrice"
                ignore-price-mode
                :showPrefix="false"
                :hide-help="!isPersonPrice || active"
                class="variant-option__price"
            >
            </Price>
        </template>

        <template v-if="hint" #hint>
            <MarketingHint :marketing-hint="hint" class="variant-option__hint" />
        </template>
    </VariantItem>
</template>

<script>
import VariantItem from '@/components/product/selection/VariantItem.vue';
import Price from '@/components/Price.vue';
import formatPrice from '@/filters/formatPrice';
import MarketingHint from '@/components/product/MarketingHint.vue';

export default {
    name: 'VariantItemOption',

    components: { MarketingHint, VariantItem, Price },

    props: {
        title: {
            type: String,
            required: true
        },

        packagePrice: {
            type: Number
        },

        personPrice: {
            type: Number
        },

        surcharge: {
            type: Number
        },

        subtitle: String,

        /**
         * @type { import('../../../models/pre-ts/product/Variant').MarketingHint }
         */
        hint: Object,

        active: Boolean,

        emphasize: Boolean,

        dense: Boolean
    },

    computed: {
        isPersonPrice() {
            return this.surcharge == null && this.personPrice != undefined;
        },

        minimumPersonPrice() {
            if (this.isPersonPrice) {
                return this.priceWithSign;
            }
            return null;
        },

        minimumPrice() {
            if (this.surcharge != null || !this.isPersonPrice) {
                return this.priceWithSign;
            }
            return null;
        },

        priceWithSign() {
            if (this.active) {
                return this.$t('Price.including');
            }

            const price =
                this.surcharge != null ? this.surcharge : this.isPersonPrice ? this.personPrice : this.packagePrice;
            // could have used signDisplay, but we need a separator between a sing and a price
            return `${price > 0 ? '+' : '-'} ${formatPrice(Math.abs(price))}`;
        }
    }
};
</script>

<style scoped lang="scss">
.variant-option {
    $self: &;
    $hint-color: hsl(190, 66%, 41%);

    min-height: 70px;

    &--emphasized:not(&#{--active}) {
        border-color: $hint-color;
        z-index: 1;
    }

    &--active {
        box-shadow: 0 5px 18px 0 hsla(0, 0%, 0%, 0.16);
        z-index: 2;
    }

    .variant-item__hint &__hint {
        $height: 33px;

        background-color: $hint-color !important;
        white-space: nowrap;
        line-height: $height;
        padding: 0 5px;
        font-size: 100%;
        justify-content: center;
        min-width: 100%;
        margin: auto;

        &::before {
            content: '';
            position: absolute;
            left: -5px;
            border: $height / 2 solid transparent;
            border-left: 0;
            border-right: 5px solid $hint-color;
        }
    }
}
</style>
